import { LogLevel } from "@azure/msal-browser";
import { createLocalUrl } from "../common/utils";
import { getAppClientIdFromConfig } from "../common/config";

export const getMsalConfig = async () => {
  const clientId = await getAppClientIdFromConfig();
  console.log("Client ID: ", clientId);
  if (!clientId || typeof clientId !== "string") {
    const errorMessage = "Client ID is not configured or is not a string. Please check your config.json file.";
    console.error(errorMessage);
    throw new Error(errorMessage);
  }
  return {
    auth: {
      clientId,
      redirectUri: createLocalUrl("auth.html"),
      postLogoutRedirectUri: createLocalUrl("auth.html"),
    },
    cache: {
      cacheLocation: "localStorage",
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Verbose,
        loggerCallback: (level: LogLevel, message: string) => {
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              console.log(message);
              return;
          }
        },
        piiLoggingEnabled: true,
      },
    },
  };
};

// Default scopes to use in the fallback dialog.
export const defaultScopes = [
  "User.Read", // for profile access
  "Mail.ReadWrite", // for accessing mailbox
  // "https://outlook.office365.com/EWS.AccessAsUser.All",
];
